import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getColumnslist } from "./columnsList";
import LoaderWrapper from "../../Utils/ViewWrapper/LoaderWrapper/LoaderWrapper";
import OrderCardAdmin from "./OrderCardAdmin";
import "./CommandesViewContent.css";
import _ from "lodash";
import { fetchCommandes } from "../../REDUX/actions/commandes";
import TextInput from "../Common/FormElements/TextInput/TextInput";
import Button from "../Common/FormElements/Button/Button";
import { SearchSVG } from "../Svgs";
import { useInView } from "react-intersection-observer";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select from "../Common/FormElements/Select/Select";
import { fetchProfiles } from "../../REDUX/actions/generalData";

const CommandesViewContent = ({ activeTab }) => {
  const { t } = useTranslation("common");
  const controllerRef = useRef(null);
  const profilesControllerRef = useRef(null);
  const dispatch = useDispatch();
  const { ref, inView, entry } = useInView({
    threshold: 0,
  });

  const { user, userRole } = useSelector((state) => state.userReducer);
  const { businessAffiliates, resellers } = useSelector(
    (state) => state.generalReducer,
  );
  const columnsList = getColumnslist(userRole, t);
  const [searchCommande, setsearchCommande] = useState("");
  const {
    commandes,
    commandeLoading,
    commandeError,
    commandesCount,
    commandeRefetchLoading,
  } = useSelector((state) => state.commandeReducer);

  const [selectedBusiness, setSelectedBusiness] = useState(undefined);
  const [selectedReseller, setSelectedReseller] = useState(undefined);
  const [page, setPage] = useState(1);
  const [sortField, setsortField] = useState("number:desc");

  useEffect(() => {
    if (inView && !commandeRefetchLoading) {
      setPage(page + 1);
      dispatch(
        fetchCommandes(
          searchCommande,
          sortField,
          {
            businessAffiliate: selectedBusiness?.code,
            reseller: selectedReseller?.code,
          },
          page,
          "Orders",
          controllerRef.current.signal,
        ),
      );
    }
  }, [inView]);

  const handleSearchCommandes = () => {
    dispatch(
      fetchCommandes(
        searchCommande,
        undefined,
        {
          businessAffiliate: selectedBusiness?.code,
          reseller: selectedReseller?.code,
        },
        undefined,
        "Orders",
        controllerRef.current.signal,
      ),
    );
  };

  // mapOrders depending on userRole
  const mapOrders = (orderData) => {
    return <OrderCardAdmin key={orderData.id} commande={orderData} />;
  };

  const getResellersList = (resellers) => {
    const filteredResellers = resellers?.filter(
      (reseller) =>
        +reseller?.attributes?.marque?.data?.id ===
        +user?.attributes?.marque?.data?.id,
    );

    if (selectedBusiness?.code) {
      return filteredResellers?.filter(
        (reseller) =>
          +reseller.attributes.business_affiliate.data?.id ===
          +selectedBusiness?.code,
      );
    } else {
      return filteredResellers?.filter(
        (reseller) =>
          !reseller?.attributes?.isMajorAccount &&
          reseller?.attributes?.marque?.id === user?.attributes?.marque?.id,
      );
    }
  };

  const handleSelectBusiness = (value) => {
    setSelectedBusiness(value);
    setSelectedReseller(undefined);
    const foundBusiness = value?.code;
    setPage(1);
    dispatch(
      fetchCommandes(
        searchCommande,
        sortField,
        { businessAffiliate: foundBusiness },
        1,
        "Orders",
        controllerRef.current.signal,
      ),
    );
  };
  const handleSelectReseller = (value) => {
    setSelectedReseller(value);
    setPage(1);
    dispatch(
      fetchCommandes(
        searchCommande,
        sortField,
        { businessAffiliate: selectedBusiness?.code, reseller: value?.code },
        1,
        "Orders",
        controllerRef.current.signal,
      ),
    );
  };

  useEffect(() => {
    controllerRef.current?.abort();
    controllerRef.current = new AbortController();

    return () => {
      dispatch({ type: "RESET_COMMANDES" });
      controllerRef.current?.abort();
    };
  }, [dispatch]);

  useEffect(() => {
    profilesControllerRef.current?.abort();
    profilesControllerRef.current = new AbortController();
    dispatch(fetchProfiles(profilesControllerRef.current.signal));
    return () => {
      profilesControllerRef.current?.abort();
    };
  }, [dispatch]);
  /* ******************************** Rendering ******************************* */
  return (
    <div className="flex-1">
      <div className="alignH justify-content-between gap-3 mb-4">
        <div>
          <h2 className="text-blue bold f30">
            {t("Orders")} ({commandesCount})
          </h2>
          <div className="d-flex gap-1">
            <span className="br5 bg-lightYelloww p-2 border-1-yellow"></span>
            <span className="f12">{t("Major account orders")} </span>
          </div>
        </div>
        <div className="d-flex align-items-end gap-3 w75">
          {userRole === "admin" && (
            <>
              <div className="">
                <p className="f16 text-ultraBlack mb-2">{t("Manager")}</p>
                <Select
                  showClear
                  resetable
                  placeholder={t("Select")}
                  callback={(e) => handleSelectBusiness(e.target.value)}
                  value={selectedBusiness}
                  options={businessAffiliates.map((el) => {
                    return { name: el.attributes.company, code: el.id };
                  })}
                  filter
                />
              </div>
            </>
          )}

          {userRole === "admin" || userRole === "BusinessBroker" ? (
            <div className="">
              <p className="f16 text-ultraBlack mb-2">{t("Store")}</p>
              <Select
                showClear
                resetable
                placeholder={t("Select")}
                callback={(e) => handleSelectReseller(e.target.value)}
                value={selectedReseller}
                options={getResellersList(resellers)?.map((el) => {
                  return { name: el.attributes.name, code: el.id };
                })}
                filter
              />
            </div>
          ) : null}
          <TextInput
            className={"flex-1"}
            placeholder={t("Search")}
            callback={(e) => setsearchCommande(e.target.value)}
          />
          <Button
            onClick={handleSearchCommandes}
            Icon={() => <SearchSVG color="white" />}
          >
            {t("Search")}
          </Button>
        </div>
      </div>
      <div className="row bg-dimGrey py-3 px-4 mx-0 w-100 d-flex justify-content-between align-items-center pointer">
        {columnsList
          ?.filter((item) => item)
          ?.map(({ title, width, sort }, index) => (
            <div
              key={index}
              className={`${width} ${
                sortField.includes(sort) ? "bold" : ""
              } text-lightBlack sBold f14`}
              onClick={() => {
                setPage(1);
                setsortField(
                  sortField.includes(sort)
                    ? sortField.includes(":desc")
                      ? `${sort}:asc`
                      : `${sort}:desc`
                    : `${sort}:desc`,
                );
                dispatch(
                  fetchCommandes(
                    searchCommande,
                    sortField.includes(sort)
                      ? sortField.includes(":desc")
                        ? `${sort}:asc`
                        : `${sort}:desc`
                      : `${sort}:desc`,
                    undefined,
                    "Orders",
                    controllerRef.current?.signal,
                  ),
                );
              }}
            >
              {title}
            </div>
          ))}
      </div>
      <LoaderWrapper loading={commandeLoading} error={commandeError}>
        {commandes.length ? commandes.map(mapOrders) : null}
      </LoaderWrapper>
      <div className="alignC py-4" ref={ref}>
        {commandeRefetchLoading ? <Spinner /> : null}
      </div>
    </div>
  );
};

export default CommandesViewContent;
